import React, { useRef } from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { ThemeExport } from '@deephaven/components';
import "./IrisGridBottomBar.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function IrisGridBottomBar(_ref) {
  var _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? 'iris-grid-bottom-bar-slide-up' : _ref$animation,
    children = _ref.children,
    className = _ref.className,
    isShown = _ref.isShown,
    onClick = _ref.onClick,
    onEntering = _ref.onEntering,
    onEntered = _ref.onEntered,
    onExiting = _ref.onExiting,
    onExited = _ref.onExited;
  var nodeRef = useRef(null);
  return /*#__PURE__*/_jsx(CSSTransition, {
    in: isShown,
    timeout: ThemeExport.transitionMs,
    classNames: animation,
    onEntering: onEntering,
    onEntered: onEntered,
    onExiting: onExiting,
    onExited: onExited,
    mountOnEnter: true,
    unmountOnExit: true,
    nodeRef: nodeRef,
    children: /*#__PURE__*/_jsx("div", {
      ref: nodeRef,
      className: classNames('iris-grid-bottom-bar', className),
      role: "presentation",
      onClick: onClick,
      onKeyPress: onClick,
      children: children
    })
  });
}
export default IrisGridBottomBar;
//# sourceMappingURL=IrisGridBottomBar.js.map